import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { GlobalService } from 'src/app/service/global.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PharmacieDto } from 'src/app/DTO/pharmacie.dto';
import { Observable, Subscription } from 'rxjs';
import { cloneDeep } from 'lodash';
import { PharmacieService } from 'src/app/service/pharmacie.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pharmacie-edit',
  templateUrl: './pharmacie-edit.component.html',
  styleUrls: ['./pharmacie-edit.component.scss']
})
export class PharmacieEditComponent implements OnInit, OnDestroy {

  @Input()
  sendFormEvent: Observable<void>;
  private sendFormEventSubscription: Subscription;

  @Output()
  private formSended: EventEmitter<boolean> = new EventEmitter();

  public pharmacieForm: FormGroup;
  public submitted = false; 

  public hideMessage: boolean;

  protected displayError = false;

  protected pharmacie: PharmacieDto;
  protected isEquipe: boolean;

  constructor(
    private formBuilder: FormBuilder,
    protected globalService: GlobalService,
    protected pharmacieService: PharmacieService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.pharmacie = this.globalService.pharmacie;
    const thisRef = this;
    this.pharmacieService.getIsEquipe().subscribe(
      data => {
        thisRef.isEquipe = (data as any).isEquipe;
        this.createForm();
      }, err => {
        console.log(err);
        //creation du formulaire avec les droits titulaires (car impossibilité de récupérer le type de compte utilisateur)
        thisRef.isEquipe = false;
        this.createForm();
      }
    );
   
    this.hideMessage = this.pharmacie.actif;

    this.sendFormEventSubscription = this.sendFormEvent.subscribe(() => this.onSubmit());
  }

  ngOnDestroy() {
    this.sendFormEventSubscription.unsubscribe();
  }

  /**
   * convenience getter for easy access to form fields
   */
  get field() {
    return this.pharmacieForm.controls;
  }

  onSubmit() {
    if(this.isEquipe === false){
      this.submitted = true;

      // stop here if form is invalid
      if (this.pharmacieForm.invalid) {
        return;
      }

      this.pharmacie = cloneDeep(this.globalService.pharmacie);
      this.pharmacie
        .setNomPhie(this.pharmacieForm.value.nomPharmacie)
        .setEmailPhie(this.pharmacieForm.value.emailPharmacie)
        .setEmailTitulaire(this.pharmacieForm.value.emailTitulaire)
        .setTelTitulaire(this.pharmacieForm.value.telephoneTitulaire)
        .setTelPhie(this.pharmacieForm.value.telephonePharmacie)
        .setNotifMailPhie(this.pharmacieForm.value.notifMailPhie)
        .setNotifSms(this.pharmacieForm.value.notifSms)
        .setNotifSmsPhie(this.pharmacieForm.value.notifSmsPhie)
        .setActif(this.pharmacieForm.value.actif);

      this.pharmacieService.putPharmacie(this.pharmacie).subscribe(data => {
        this.toastr.success("Informations mises à jour avec succès !");
        this.globalService.pharmacie = PharmacieDto.fromJson(data);
        this.globalService.emitPharmacieActifEvent(this.globalService.pharmacie.actif);
        this.formSended.emit(true);
      });
    }else{
      this.toastr.error("Impossible de mettre à jour les informations de la pharmacie via un compte équipe.");
    }

  }

  createForm(){
    if (this.isEquipe === false){
      this.pharmacieForm = this.formBuilder.group({
        codeSogiphar: this.formBuilder.control({value: this.pharmacie.codeSogiphar, disabled: true}),
        nomPharmacie: this.formBuilder.control({value: this.pharmacie.nomPhie, disabled: false}, [Validators.required]),
        codePostal: this.formBuilder.control({value: this.pharmacie.codePostal, disabled: true}),
        emailPharmacie: this.formBuilder.control({value:this.pharmacie.emailPhie,  disabled: false}, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
        nomTitulaire: this.formBuilder.control({value: this.pharmacie.nomTitulaire, disabled: true}),
        prenomTitulaire: this.formBuilder.control({value: this.pharmacie.prenomTitulaire, disabled: true}),
        emailTitulaire: this.formBuilder.control({value:this.pharmacie.emailTitulaire, disabled: false},[Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
        telephoneTitulaire: this.formBuilder.control({value:this.pharmacie.telTitulaire, disabled: false}, [Validators.required]),
        telephonePharmacie: this.formBuilder.control({value: this.pharmacie.telPhie, disabled: false}, [Validators.required]),
        notifMailPhie: this.formBuilder.control({value:this.pharmacie.notifMailPhie, disabled: false}),
        notifMailPhien: this.formBuilder.control({value: this.pharmacie.notifMailPhien, disabled: true}),
        notifSmsPhie: this.formBuilder.control({value: this.pharmacie.notifSmsPhie, disabled: false}),
        notifSms: this.formBuilder.control({value: this.pharmacie.notifSms, disabled: false}),
        actif: this.formBuilder.control({value: this.pharmacie.actif, disabled: false}),
      });
    }else{
      this.pharmacieForm = this.formBuilder.group({
        codeSogiphar: this.formBuilder.control({value: this.pharmacie.codeSogiphar, disabled: true}),
        nomPharmacie: this.formBuilder.control({value: this.pharmacie.nomPhie, disabled: true}, [Validators.required]),
        codePostal: this.formBuilder.control({value: this.pharmacie.codePostal, disabled: true}),
        emailPharmacie: this.formBuilder.control({value:this.pharmacie.emailPhie,  disabled: true}, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
        nomTitulaire: this.formBuilder.control({value: this.pharmacie.nomTitulaire, disabled: true}),
        prenomTitulaire: this.formBuilder.control({value: this.pharmacie.prenomTitulaire, disabled: true}),
        emailTitulaire: this.formBuilder.control({value:this.pharmacie.emailTitulaire, disabled: true},[Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
        telephoneTitulaire: this.formBuilder.control({value:this.pharmacie.telTitulaire, disabled: true}, [Validators.required]),
        telephonePharmacie: this.formBuilder.control({value: this.pharmacie.telPhie, disabled: true}, [Validators.required]),
        notifMailPhie: this.formBuilder.control({value:this.pharmacie.notifMailPhie, disabled: true}),
        notifMailPhien: this.formBuilder.control({value: this.pharmacie.notifMailPhien, disabled: true}),
        notifSmsPhie: this.formBuilder.control({value: this.pharmacie.notifSmsPhie, disabled: true}),
        notifSms: this.formBuilder.control({value: this.pharmacie.notifSms, disabled: true}),
        actif: this.formBuilder.control({value: this.pharmacie.actif, disabled: true}),
      });
    }
  }

}
